<template>
  <div id="index">
    <WaluntIndex msg='111是大大大大大'/>
  </div>
</template>

<script>
import WaluntIndex from "./components/WaluntIndex.vue";

export default {
  name: "app",
  components: {
    WaluntIndex
  }
};
</script>

<style>
#index {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*{
  margin: 0;
  padding: 0;
}
.swiper-pagination-bullet-active {
  background-color: #707070;
}
</style>
